const SUPPORT_LANGS = [
  {
    value: 'ru',
    title: 'Русский',
    hrefLang: 'ru', // для канонических ссылок
  },
  {
    value: 'en',
    title: 'English',
    hrefLang: 'en',
  },
  {
    value: 'de',
    title: 'Deutsch',
    hrefLang: 'de', // для канонических ссылок
  },
  {
    value: 'es',
    title: 'Español',
    hrefLang: 'es', // для канонических ссылок
  },
];

const LANG_CAPTION = {
  ru: 'Ru',
  en: 'En',
  de: 'De',
  es: 'Es',
};

const OLD_LANGS = ['br', 'pt', 'tr', 'fi', 'cn', 'jp', 'th'];

const PRIMARY_LANG = {
  value: 'ru',
  title: 'Русский',
  hrefLang: 'ru',
};

const DEFAULT_LANG = {
  value: 'en',
  title: 'English',
  hrefLang: 'en',
};

const DEFAULT_LOCALE = 'default';

// node не поддерживает es6 модули
module.exports = {
  SUPPORT_LANGS,
  OLD_LANGS,
  PRIMARY_LANG,
  DEFAULT_LANG,
  DEFAULT_LOCALE,
  LANG_CAPTION,
};
